export default () => (
	<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clip-path="url(#bwrgsnwjia)">
			<path
				d="M8.75 18.75h8.75v2.5H8.75v-2.5zm0-5h12.5v2.5H8.75v-2.5zm0-5h12.5v2.5H8.75v-2.5zm15-5h-5.225C18 2.3 16.625 1.25 15 1.25s-3 1.05-3.525 2.5H6.25a2.19 2.19 0 0 0-.5.05c-.487.1-.925.35-1.263.688-.224.224-.412.5-.537.8-.125.287-.2.612-.2.962v17.5c0 .337.075.675.2.975.125.3.313.563.537.8a2.51 2.51 0 0 0 1.263.688c.162.024.325.037.5.037h17.5c1.375 0 2.5-1.125 2.5-2.5V6.25c0-1.375-1.125-2.5-2.5-2.5zM15 3.437c.512 0 .938.425.938.938a.944.944 0 0 1-.938.938.944.944 0 0 1-.938-.938c0-.513.426-.938.938-.938zm8.75 20.313H6.25V6.25h17.5v17.5z"
				fill="#7EA6B4"
			/>
		</g>
		<circle cx="25" cy="25" r="7" fill="#ED544D" />
		<path
			d="M25.652 28.241c0 .375-.31.68-.695.68a.687.687 0 0 1-.694-.68c0-.375.31-.68.694-.68.384 0 .695.305.695.68zM25.912 21.903a1.003 1.003 0 0 0-.209-.524.952.952 0 0 0-.745-.379.95.95 0 0 0-.73.359 1.005 1.005 0 0 0-.225.707l.396 4.426a.54.54 0 0 0 .161.34.567.567 0 0 0 .957-.34l.395-4.426a.984.984 0 0 0 0-.163z"
			fill="#fff"
		/>
		<defs>
			<clipPath id="bwrgsnwjia">
				<path fill="#fff" d="M0 0h30v30H0z" />
			</clipPath>
		</defs>
	</svg>
);
